/**
 * API Constants and Configuration
 * Uses centralized environment configuration
 * Configure environments in src/config/environments.js
 */

import ENV_CONFIG from './environments';

export const API_CONFIG = {
  BASE_URL: ENV_CONFIG.baseUrl,
  CACHE_DURATION: ENV_CONFIG.cacheDuration,
  RETRY_ATTEMPTS: ENV_CONFIG.retryAttempts,
  TIMEOUT: ENV_CONFIG.timeout,
};

// API Endpoints
export const ENDPOINTS = {
  // Services
  SERVICES: '/services',
  SERVICE_BY_ID: (id) => `/services/${id}`,
  
  // Products
  PRODUCTS: '/products',
  PRODUCT_BY_ID: (id) => `/products/${id}`,
  
  // Vendors
  VENDORS: '/vendors',
  FEATURED_VENDORS: '/vendors/featured',
  VENDOR_BY_ID: (id) => `/vendors/${id}`,
  VENDOR_REVIEWS: (id) => `/vendors/${id}/reviews`,
  
  // Search
  SEARCH: '/search',
  SEARCH_SUGGESTIONS: '/search/suggestions',
  
  // Location
  CITIES: '/cities',
  AREAS: '/areas',
  AREAS_BY_CITY: (cityId) => `/areas?city_id=${cityId}`,
  DETECT_LOCATION: '/detect-location',
  
  // Categories
  CATEGORIES: '/categories',
  
  // Tags
  TAGS: '/tags',
  VENDOR_TAGS: (vendorId) => `/vendors/${vendorId}/tags`,
  
  // User Categories
  USER_CATEGORIES: (userId) => `/users/${userId}/categories`,
  USER_CATEGORY_HIERARCHY: (userId) => `/users/${userId}/categories/hierarchy`,
  USER_CATEGORIES_ALL: (userId) => `/users/${userId}/categories/all`,
  
  // Auth
  REGISTER: '/register',
  LOGIN: '/login',
  LOGOUT: '/logout',
  REQUEST_OTP: '/auth/request-otp',
  VERIFY_OTP: '/auth/verify-otp',
  VERIFY_PHONE: '/auth/verify-phone',
  CHECK_PHONE: '/auth/check-phone',
  
  // Admin API
  ADMIN_API: '/admin',
};

// Headers
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
};

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = { ...DEFAULT_HEADERS };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};
